import {Component, OnInit, Input, ViewChild, OnDestroy} from '@angular/core';
import {Project} from '../../../data/project/project';
import {OverlayPanel} from 'primeng/overlaypanel';
import {SearchService} from '../../../../search/data/search.service';
import {ProjectService} from '../../../data/project/project.service';
import {MatDialog} from '@angular/material/dialog';
import {CustomerService} from '../../../../customer/data/customer.service';
import {WsUpdateResponce} from '../../../../data/ws-update-responce';
import {Customer} from '../../../../customer/data/customer';
import {WsService} from '../../../../data/ws.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {takeUntilDestroyed} from 'projects/core/src/public-api';
import {debounceTime, filter, takeUntil} from 'rxjs/operators';
import {Subject, Subscription} from 'rxjs';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';

@Component({
  selector: 'app-customer-block',
  templateUrl: './customer-block.component.html',
  styleUrls: ['./customer-block.component.scss'],
  providers: [SearchService, DeviceDetectorService]
})
@RxJSUnsubscribe
export class CustomerBlockComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  @Input()
  project: Project

  @ViewChild('searchOP', {static: true})
  searchOP: OverlayPanel

  searchValue: string;

  subjSub: Subscription;

  wsSub: Subscription;

  constructor(
    protected deviceDetector: DeviceDetectorService,
    protected dialog: MatDialog,
    protected customerService: CustomerService,
    protected projectService: ProjectService,
    protected wsService: WsService
  ) {
  }

  ngOnInit() {
    this.wsSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<Customer>>('/topic/update/model.customer.Customer', this)
      .pipe(
        filter(updateInfo => this.project.customer && updateInfo.entity.id === this.project.customer.id),
        debounceTime(100)
      )
      .subscribe(updateInfo => {
        if (updateInfo.action === 'UPDATE') {
          this.getCustomer(updateInfo.entity.id)
        }
      })

    this.subToContacts();
  }

  getCustomer(customerId: number) {
    this.customerService.getCustomer(customerId).subscribe(cust => {
      this.project.customer = cust
    })
  }

  subToContacts() {
    this.subjSub = this.customerService.nfsContacts.subscribe(contactObj => {
      this.project.notificationContacts = contactObj.selectedContacts
      this.project.customer.contacts = contactObj.allContacts
    })
  }

  callPhone() {
    if (this.deviceDetector.isMobile() || this.deviceDetector.isTablet()) {
      if (this.project.customer.billingInfoContact.phone1) {
        window.open('tel:' + this.project.customer.billingInfoContact.phone1);
      }
    }
  }

  sendEmail() {
    if (this.project.customer.billingInfoContact.email) {
      window.open('email:' + this.project.customer.billingInfoContact.email);
    }
  }

  transform(rawNum) {
    if (rawNum) {
      rawNum = rawNum.charAt(0) !== 0 ? '0' + rawNum : '' + rawNum;

      let newStr = '';
      let i = 0;

      for (; i < Math.floor(rawNum.length / 2) - 1; i++) {
        newStr = newStr + rawNum.substr(i * 2, 2) + '-';
      }

      return newStr + rawNum.substr(i * 2);
    }
    return '';
  }

  ngOnDestroy() {
    if (this.subjSub) {
      this.subjSub.unsubscribe();
    }
    if (this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }


}
